import { render, staticRenderFns } from "./private-sales-about.vue?vue&type=template&id=7276b009&scoped=true&"
import script from "./private-sales-about.vue?vue&type=script&lang=js&"
export * from "./private-sales-about.vue?vue&type=script&lang=js&"
import style0 from "./private-sales-about.vue?vue&type=style&index=0&id=7276b009&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7276b009",
  null
  
)

export default component.exports